import { memo } from 'react';

import { PresentationIcon } from '@air/design-icons';

import { NonContributableEmptyState } from '~/components/NonContributableNullState/NonContributableNullState';

export const PublicShowcaseNullState = memo(() => (
  <NonContributableEmptyState
    icon={PresentationIcon}
    title="No content yet"
    description="Assets and boards added to this showcase will appear here."
  />
));

PublicShowcaseNullState.displayName = 'PublicShowcaseNullState';
